import { useEffect, useState } from "react";

import { Box, Typography, TextField, InputAdornment } from "@mui/material";
import { Numbers } from "@mui/icons-material";

const NumericInput = ({label, placeholder, sufixText, helperText, value, min, max, setter}) => {
  const handleNumericInput = (
    value: string
  ) => {
    // Permitir solo números enteros
    const numericValue = value.replace(/[^0-9]/g, "");

    if (numericValue === "") {
      setter("");
      return;
    }

    const num = Number.parseInt(numericValue);
    if (num >= min && num <= max) {
      setter(numericValue);
    } else if (num < min) {
      setter(min.toString());
    } else if (num > max) {
      setter(max.toString());
    }
  };
  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
        <Numbers sx={{ color: "#6B7280", fontSize: 16 }} />
        <Typography
          variant="body2"
          fontWeight="bold"
          sx={{ fontSize: "0.85rem" }}
        >
          {label}
        </Typography>
      </Box>
      <TextField
        fullWidth
        size="small"
        value={value}
        onChange={(e) => handleNumericInput(e.target.value)}
        placeholder={placeholder}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end" sx={{ fontSize: "0.75rem" }}>
              {sufixText}
            </InputAdornment>
          ),
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            backgroundColor: "#F9FAFB",
            fontSize: "0.8rem",
          },
        }}
        helperText={helperText}
        error={
          value !== "" &&
          (Number.parseInt(value) < min || Number.parseInt(value) > max)
        }
      />
    </>
  );
};

export default NumericInput;
